import {Box} from '@mui/material';
import {array, node, object} from 'prop-types';
import React, {useEffect, useState} from 'react';

const Overlay = props => {
  const [pixel, setPixel] = useState([0, 0]);
  const [display, setDisplay] = useState('none');

  const getPixel = () => {
    const position = props.coordinate;
    return props.map.getPixelFromCoordinate(position);
  };

  const updatePosition = () => {
    setPixel(getPixel());
    setDisplay('block');
  };

  const hide = () => {
    setDisplay('none');
  };

  useEffect(() => {
    props.map.on('render', hide);
    props.map.on('postrender', updatePosition);

    return () => {
      props.map.un('render', hide);
      props.map.un('postrender', updatePosition);
    };
  });

  return (
    <Box
      sx={{
        position: 'absolute',
        left: 0,
        top: 0,
        transition: 'transform',
        pointerEvents: 'none',
        transform: `translate(2px, -50%) translate(${pixel[0]}px, ${pixel[1]}px)`,
        display,
      }}
    >
      {props.children}
    </Box>
  );
};

Overlay.propTypes = {
  coordinate: array,
  map: object.isRequired,
  children: node,
};

export default Overlay;
